module.exports = __webpack_public_path__ + "assets/img/5-3.547de6b7.png";